import React from 'react';
import { useNavigate } from 'react-router-dom';
import GamePrice from './GamePrice';

function CreatorBundleCard({ bundle, onPurchaseClick, isAuthenticated, ownedGameIds }) {
  const navigate = useNavigate();
  const ownsAllGames = bundle.games.every((game) => ownedGameIds.includes(game.id));
  const isOwned = ownsAllGames;
  const creator = bundle.creator;

  const handleCreatorClick = () => {
    if (creator?.id) {
      window.scrollTo(0, 0);
      navigate(`/creator/${creator.id}`);
    }
  };

  return (
    <div className="bg-gradient-to-br from-dark-card to-dark-surface border border-dark-border rounded-3xl overflow-hidden shadow-xl hover:shadow-2xl hover:shadow-accent-blue/20 transition-all duration-300">
      <div className="p-6 lg:p-8">
        <div className="flex items-start gap-4 lg:gap-6 mb-6 pb-6 border-b border-dark-border">
          <button
            type="button"
            onClick={handleCreatorClick}
            className="flex-shrink-0 group/creator"
            aria-label={creator ? `View ${creator.name}` : undefined}
          >
            <div className="w-16 h-16 lg:w-20 lg:h-20 rounded-2xl overflow-hidden border-2 border-dark-border group-hover/creator:border-accent-blue/50 transition-colors">
              {creator?.pfp ? (
                <img
                  src={creator.pfp}
                  alt={creator.name}
                  className="w-full h-full object-cover group-hover/creator:scale-105 transition-transform duration-300"
                />
              ) : (
                <div className="w-full h-full bg-accent-blue/20 flex items-center justify-center">
                  <span className="text-2xl font-bold text-accent-blue/70">
                    {(creator?.name || bundle.title).charAt(0)}
                  </span>
                </div>
              )}
            </div>
          </button>

          <div className="flex-1 min-w-0">
            {creator && (
              <button
                type="button"
                onClick={handleCreatorClick}
                className="text-white/70 font-semibold text-sm lg:text-base hover:text-white transition-colors mb-1"
              >
                {creator.name}
              </button>
            )}
            <h3 className="text-xl lg:text-2xl font-semibold text-white leading-tight">
              {bundle.title}
            </h3>
            <p className="text-white/50 text-sm mt-1.5">
              {bundle.games.length} {bundle.games.length === 1 ? 'game' : 'games'} included
            </p>
          </div>
        </div>

        <div className="mb-6">
          <div className="bundle-games-scroll flex gap-3 lg:gap-4 overflow-x-auto pb-2">
            {bundle.games.map((game) => (
              <button
                key={game.id}
                type="button"
                onClick={() => navigate(`/game/${game.id}`)}
                className="flex-shrink-0 w-56 sm:w-60 lg:w-72 group/game text-left"
              >
                <div className="aspect-[16/9] rounded-xl overflow-hidden border border-dark-border bg-dark-bg/40 group-hover/game:border-accent-blue/40 transition-all duration-200 shadow-md group-hover/game:shadow-accent-blue/10">
                  {game.mainImage ? (
                    <img
                      src={game.mainImage}
                      alt={game.title}
                      className="w-full h-full object-cover group-hover/game:scale-105 transition-transform duration-300"
                    />
                  ) : (
                    <div className="w-full h-full flex items-center justify-center text-white/30 text-xs">
                      No image
                    </div>
                  )}
                </div>
                <div className="mt-2 px-0.5">
                  <div className="text-white text-xs lg:text-sm font-medium leading-snug line-clamp-2">
                    {game.title}
                  </div>
                  <div className="mt-1">
                    <GamePrice game={game} size="sm" />
                  </div>
                </div>
              </button>
            ))}
          </div>
        </div>

        <div className="flex items-center justify-between pt-4 border-t border-dark-border">
          <GamePrice bundle={bundle} size="lg" />
          <button
            onClick={() => onPurchaseClick(bundle)}
            disabled={!isAuthenticated || isOwned}
            className="py-3 px-6 bg-white text-dark-bg font-semibold rounded-xl hover:bg-white/90 shadow-lg shadow-black/20 transition-all duration-200 disabled:opacity-50 disabled:cursor-not-allowed"
          >
            {!isAuthenticated ? 'Sign In to Purchase' : isOwned ? 'Owned' : 'Purchase'}
          </button>
        </div>
      </div>
    </div>
  );
}

export default CreatorBundleCard;
